// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"_f45e817"};